/* @ngInject */
const myRailwayDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myRailway: '=',
      myWagons: '=',
      enablePosition: '=?',
      enableButtons: '=?',
      enableTitle: '=?',
      enableLinks: '=?',
      enableBack: '=?',
    },
    template: require('./myRailwayDisplay.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.modifPos = false
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myRailwayDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/directives/display/myRailwayDisplay.js